import { useMutation } from "@tanstack/react-query";
import { deleteUser } from "supabase/users";
import { queryClient } from "utils";

type UseDeleteUserParams = {
  uid: string;
};

export const useDeleteUser = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ uid }: UseDeleteUserParams) => {
      return deleteUser({ uid });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });

      onSuccess();
    },
  });

  return mutation;
};
